export default __webpack_public_path__ + "static/media/shareFb.f4de9d9b.svg";